/**
 * Hide unopened navigation items on collection pages
 * Handles both 2-layer and 3-layer navigation structures
 */

$(document).ready(function() {
    // Check if we're on a collection page (but NOT /collections/all)
    if (window.location.pathname.includes('/collections/') && window.location.pathname !== '/collections/all') {
        
        // First, check if any navPages-item has is-clicked
        var hasClickedItem = $('.navPages-item.is-clicked').length > 0;

        if (!hasClickedItem) {
            // No top-level item is marked as clicked
            // Try to find the matching item based on URL
            var currentPath = window.location.pathname;
            
            // Try to find exact match in navPages-item first
            $('.navPages-item a.navPages-action').each(function() {
                var href = $(this).attr('href');
                if (href && currentPath.includes(href)) {
                    $(this).closest('.navPages-item').addClass('is-clicked');
                    return false; // break
                }
            });
            
            // If still no match, try to find in any child link
            if ($('.navPages-item.is-clicked').length === 0) {
                $('.navPage-subMenu-item a').each(function() {
                    var href = $(this).attr('href');
                    if (href && currentPath.includes(href)) {
                        // Mark the child as clicked
                        $(this).closest('.navPage-subMenu-item').addClass('is-clicked');
                        // Mark the parent navPages-item as clicked
                        $(this).closest('.navPages-item').addClass('is-clicked');
                        return false; // break
                    }
                });
            }
        }
        
        // SIMPLE LOGIC: Only hide top-level navPages-item that are NOT clicked
        // Show ALL descendants of clicked top-level items
        $('.navPages-item:not(.is-clicked)').hide();
        
        // Make sure all descendants of clicked items are visible
        $('.navPages-item.is-clicked').find('.navPage-subMenu-item').show();

        // Hide category filter if no items to show
        if($('.navPages-item.is-clicked').find('.navPage-subMenu-item').length == 0){
            $('.sidebar-categories').hide();
        }
        
        // Add smooth transition effect
        $('.navPages-item.is-clicked, .navPage-subMenu-item.is-clicked').css({
            'display': 'list-item',
            'opacity': '1'
        });
    }
    
    // ==========================================
    // Vertical Menu - Open on Hover
    // ==========================================
    
    const $verticalMenu = $('.vertical-menu.p-relative.sticky_effect');
    
    // Open menu on mouse enter
    $verticalMenu.on('mouseenter', function() {
        $(this).removeClass('vertical-menu__hide');
        $(this).addClass('vertical-menu__open');
    });
    
    // Close menu on mouse leave
    $verticalMenu.on('mouseleave', function() {
        $(this).removeClass('vertical-menu__open');
        $(this).addClass('vertical-menu__hide');
    });
});




function scrollToDescription(event) {
    event.preventDefault();
    
    // Remove is-active class from all tabs and tab contents
    $('.tabs .tab').removeClass('is-active');
    $('.tabs-contents .tab-content').removeClass('is-active');
    
    // Find and activate the descriere tab
    var descriereTab = $('#tab-descriere');
    var descriereTabLink = $('a[href="#tab-descriere"]').parent('.tab');
    
    // Activate the descriere tab link
    if (descriereTabLink.length) {
        descriereTabLink.addClass('is-active');
    }
    
    // Activate the descriere tab content
    if (descriereTab.length) {
        descriereTab.addClass('is-active');
        
        // Scroll to the tab with offset
        var offset = 150;
        var targetPosition = descriereTab.offset().top - offset;
        
        $('html, body').animate({
            scrollTop: targetPosition
        }, 600); // 600ms animation duration
    }
}

function openDescriereMobile() {
    // Activează tabul principal
    $('#tab-descriere').addClass('is-active');

    // Activează toggleLink-ul din interiorul tabului
    $('#tab-descriere .toggleLink').addClass('is-open');

    // Activează conținutul mobil
    $('#tab-descriere-mobile')
        .addClass('is-active')
        .css('display', 'block');
}

$(document).ready(function () {
    if (window.innerWidth <= 768) {
        // Așteaptă ca tema să termine inițializarea
        setTimeout(openDescriereMobile, 100);
    }
});

// Dacă tema reîncarcă secțiunea (ex: AJAX), aplicăm din nou
$(document).on('theme:section:load', function () {
    if (window.innerWidth <= 768) {
        openDescriereMobile();
    }
});




// ============================================================
// Globo Product Options – mutăm .gpo-container ca frate al
// .productView-group (chiar înaintea lui), ca să apară pe toată
// lățimea formularului, deasupra cantității + butonului ATC.
// ============================================================
(function () {
    var LOADER_TIMEOUT_MS = 4000; // dacă Globo nu apare în 4s, scoatem loader-ul

    function ensureLoader(form) {
        if (form.dataset.gpoLoaderHandled === '1') return;
        var pvGroup = form.querySelector('.productView-group');
        if (!pvGroup || !pvGroup.parentNode) return;

        var loader = document.createElement('div');
        loader.className = 'gpo-loading-placeholder';
        loader.setAttribute('aria-live', 'polite');
        loader.innerHTML =
            '<span class="gpo-loading-spinner" aria-hidden="true"></span>' +
            '<span class="gpo-loading-text">Se încarcă opțiunile...</span>';
        pvGroup.parentNode.insertBefore(loader, pvGroup);

        form.dataset.gpoLoaderHandled = '1';

        setTimeout(function () {
            if (loader.parentNode) loader.parentNode.removeChild(loader);
        }, LOADER_TIMEOUT_MS);
    }

    function removeLoader(form) {
        var loader = form.querySelector('.gpo-loading-placeholder');
        if (loader && loader.parentNode) loader.parentNode.removeChild(loader);
    }

    function moveGpoContainer(form) {
        var gpo = form.querySelector('.gpo-container');
        if (!gpo) return false;
        if (gpo.dataset.movedAbovePvGroup === '1') return true;

        var pvGroup = form.querySelector('.productView-group');
        if (!pvGroup || !pvGroup.parentNode) return false;

        pvGroup.parentNode.insertBefore(gpo, pvGroup);
        gpo.dataset.movedAbovePvGroup = '1';
        removeLoader(form);
        return true;
    }

    function getForms() {
        return document.querySelectorAll('product-form.productView-form, product-form.product-form');
    }

    function injectLoaders() {
        getForms().forEach(ensureLoader);
    }

    function processAllForms() {
        getForms().forEach(moveGpoContainer);
    }

    function startObserver() {
        var debounce = null;
        var observer = new MutationObserver(function (mutations) {
            var touched = mutations.some(function (m) {
                return Array.from(m.addedNodes).some(function (node) {
                    if (node.nodeType !== 1) return false;
                    if (node.matches && node.matches('.gpo-container')) return true;
                    if (node.querySelector && node.querySelector('.gpo-container')) return true;
                    return false;
                });
            });
            if (!touched) return;
            clearTimeout(debounce);
            debounce = setTimeout(processAllForms, 60);
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    function init() {
        injectLoaders();
        processAllForms();
        startObserver();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.addEventListener('theme:section:load', function () {
        injectLoaders();
        processAllForms();
    });
})();

// ============================================================
// Înlocuiește "0,00 lei" cu un mesaj pe produsele cu preț 0
// (cele care depind de selecția Globo Product Options).
// Se reactivează cu MutationObserver ca să comute mesaj ↔ preț
// real când Globo actualizează totalul după selecție.
// ============================================================
(function () {
    var ZERO_MESSAGE = 'Selectează opțiunile pentru a vedea prețul';

    function isZeroText(text) {
        if (!text) return true;
        var cleaned = text.replace(/\s+/g, '');
        return /^0([.,]0+)?(lei|RON)?$/i.test(cleaned);
    }

    function getGpoTotalMoney() {
        var totalTexts = document.querySelectorAll('.gpo-total-text');
        for (var i = 0; i < totalTexts.length; i++) {
            var money = totalTexts[i].querySelector('.money');
            if (!money) continue;
            var text = (money.textContent || '').trim();
            if (text && !isZeroText(text)) return text;
        }
        return null;
    }

    function processPrice(priceEl) {
        // Aplicăm doar pe produsele cu preț de bază 0 (marcat de WPD)
        if (!priceEl.querySelector('[data-wpd-variant-price="0"]')) return;

        var items = priceEl.querySelectorAll('.price-item');
        var visibleTexts = [];
        items.forEach(function (el) {
            if (el.classList.contains('data-wpd-hide')) return;
            // Ignorăm <s> (strikethrough compare-at)
            if (el.tagName.toLowerCase() === 's') return;
            visibleTexts.push((el.textContent || '').trim());
        });

        var allZero = visibleTexts.length > 0 && visibleTexts.every(isZeroText);

        var existingMsg = priceEl.querySelector('.price-zero-message');
        var innerPrice = priceEl.querySelector('.price');

        if (allZero) {
            // Dacă Globo are deja o sumă în gpo-total-text, o afișăm în loc de mesaj
            var gpoMoney = getGpoTotalMoney();
            var msgText = gpoMoney || ZERO_MESSAGE;
            var msgIsPrice = !!gpoMoney;

            priceEl.classList.add('is-zero-price');
            if (innerPrice) innerPrice.style.setProperty('display', 'none', 'important');

            if (!existingMsg) {
                existingMsg = document.createElement('div');
                existingMsg.className = 'price-zero-message';
                priceEl.appendChild(existingMsg);
            }
            if (existingMsg.textContent !== msgText) {
                existingMsg.textContent = msgText;
            }
            existingMsg.classList.toggle('price-zero-message--has-price', msgIsPrice);

            // Belt-and-suspenders: setăm inline style ca să batem orice CSS din temă
            if (msgIsPrice) {
                existingMsg.style.setProperty('font-size', '24px', 'important');
                existingMsg.style.setProperty('font-style', 'normal', 'important');
            } else {
                existingMsg.style.removeProperty('font-size');
                existingMsg.style.removeProperty('font-weight');
                existingMsg.style.removeProperty('font-style');
            }
        } else {
            priceEl.classList.remove('is-zero-price');
            if (innerPrice) innerPrice.style.removeProperty('display');
            if (existingMsg) existingMsg.remove();
        }
    }

    // Watcher separat pe .gpo-container ca să reprocesăm prețul când Globo actualizează totalul
    function watchGpoTotals() {
        document.querySelectorAll('.gpo-container').forEach(function (gpoWrap) {
            if (gpoWrap.dataset.priceMirrorWatched === '1') return;
            gpoWrap.dataset.priceMirrorWatched = '1';

            var debounce = null;
            var obs = new MutationObserver(function () {
                clearTimeout(debounce);
                debounce = setTimeout(function () {
                    document.querySelectorAll('.productView-price').forEach(processPrice);
                }, 50);
            });
            obs.observe(gpoWrap, {
                childList: true,
                subtree: true,
                characterData: true,
                attributes: true,
                attributeFilter: ['style', 'class']
            });
        });
    }

    function setupPriceObservers() {
        document.querySelectorAll('.productView-price').forEach(function (priceEl) {
            if (priceEl.dataset.zeroPriceWatched === '1') {
                processPrice(priceEl);
                return;
            }
            priceEl.dataset.zeroPriceWatched = '1';

            var debounce = null;
            var obs = new MutationObserver(function () {
                clearTimeout(debounce);
                debounce = setTimeout(function () { processPrice(priceEl); }, 50);
            });
            obs.observe(priceEl, {
                childList: true,
                subtree: true,
                characterData: true
            });

            processPrice(priceEl);
        });

        watchGpoTotals();
    }

    // Când Globo își injectează containerul în DOM, atașăm observer-ul
    var gpoAppearObs = new MutationObserver(function (mutations) {
        var found = mutations.some(function (m) {
            return Array.from(m.addedNodes).some(function (node) {
                if (node.nodeType !== 1) return false;
                if (node.matches && node.matches('.gpo-container')) return true;
                if (node.querySelector && node.querySelector('.gpo-container')) return true;
                return false;
            });
        });
        if (found) {
            watchGpoTotals();
            document.querySelectorAll('.productView-price').forEach(processPrice);
        }
    });
    if (document.body) gpoAppearObs.observe(document.body, { childList: true, subtree: true });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupPriceObservers);
    } else {
        setupPriceObservers();
    }

    document.addEventListener('theme:section:load', setupPriceObservers);
})();

// ============================================================
// Pe carduri (colecții / search / related), ascunde "0,00 lei"
// pentru produsele Pachet KLINO cu preț 0 și pune "Vezi opțiuni".
// ============================================================
(function () {
    var PRICE_MAP = {
        '15985832100222': 'De la 93,44 lei',
        '15986219549054': 'De la 186,88 lei'
    };
    var TARGET_IDS = Object.keys(PRICE_MAP);

    function isZeroText(text) {
        if (!text) return true;
        var cleaned = text.replace(/\s+/g, '');
        return /^0([.,]0+)?(lei|RON)?$/i.test(cleaned);
    }

    function processCardPrice(priceItem) {
        // Ignorăm pagina de produs (e gestionată în blocul anterior)
        if (priceItem.closest('.productView-price')) return;

        var productId = priceItem.getAttribute('data-wpd-product-id');
        var cardMessage = PRICE_MAP[productId];
        if (!cardMessage) return;

        var priceWrap = priceItem.closest('.price');
        if (!priceWrap) return;

        var allItems = priceWrap.querySelectorAll('.price-item');
        var visibleTexts = [];
        allItems.forEach(function (el) {
            if (el.classList.contains('data-wpd-hide')) return;
            if (el.tagName.toLowerCase() === 's') return;
            visibleTexts.push((el.textContent || '').trim());
        });
        var allZero = visibleTexts.length > 0 && visibleTexts.every(isZeroText);

        var existingMsg = priceWrap.querySelector('.price-card-zero-message');
        var dl = priceWrap.querySelector('dl');

        if (allZero) {
            if (dl) dl.style.setProperty('display', 'none', 'important');
            if (!existingMsg) {
                var msg = document.createElement('div');
                msg.className = 'price-card-zero-message';
                msg.textContent = cardMessage;
                priceWrap.appendChild(msg);
            } else if (existingMsg.textContent !== cardMessage) {
                existingMsg.textContent = cardMessage;
            }
        } else {
            if (dl) dl.style.removeProperty('display');
            if (existingMsg) existingMsg.remove();
        }
    }

    function processAllCards() {
        TARGET_IDS.forEach(function (id) {
            document
                .querySelectorAll('.price-item[data-wpd-product-id="' + id + '"]')
                .forEach(processCardPrice);
        });
    }

    function init() {
        processAllCards();
        var debounce = null;
        var obs = new MutationObserver(function () {
            clearTimeout(debounce);
            debounce = setTimeout(processAllCards, 100);
        });
        obs.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.addEventListener('theme:section:load', processAllCards);
})();


// ============================================================
// HulkApps → Appstle Loyalty sync
// Sincronizează cantitatea selectată în HulkApps cu inputul standard
// de cantitate, astfel încât Appstle recalculează punctele instant.
// Se declanșează la:
//   1. Click pe opțiune HulkApps (1 bucată, 3 bucăți etc.)
//   2. Schimbare de variantă Shopify (Bucată ↔ Bax)
// ============================================================
(function () {
    function syncQuantityToAppstle(qty) {
        var qtyInput = document.querySelector('input[name="quantity"].quantity__input, input[name="quantity"]');
        if (!qtyInput) return;
        qtyInput.value = qty;
        ['input', 'change'].forEach(function (evtName) {
            qtyInput.dispatchEvent(new Event(evtName, { bubbles: true }));
        });
    }

    // Citește cantitatea din opțiunea selectată în containerul HulkApps activ
    function syncFromActiveHulkAppsContainer() {
        var containers = document.querySelectorAll('.hulkapps-volume-discount-tiers');
        for (var i = 0; i < containers.length; i++) {
            var c = containers[i];
            // Ignorăm containerele ascunse
            if (c.offsetParent === null) continue;
            var checked = c.querySelector('input[type="radio"]:checked');
            if (!checked) continue;
            var qty = parseInt(checked.value, 10);
            if (!isNaN(qty) && qty >= 1) {
                syncQuantityToAppstle(qty);
                return;
            }
        }
    }

    // 1. Click pe opțiune HulkApps
    document.addEventListener('click', function (e) {
        var item = e.target.closest('.offer-option-item');
        if (!item) return;
        setTimeout(function () {
            var radio = item.querySelector('input[type="radio"]');
            if (!radio) return;
            var qty = parseInt(radio.value, 10);
            if (!isNaN(qty) && qty >= 1) syncQuantityToAppstle(qty);
        }, 50);
    });

    // 2. Schimbare de variantă Shopify (Bucată ↔ Bax)
    // variants.js dispatch-uiește 'change' pe .product-form__radio la fiecare switch
    document.addEventListener('change', function (e) {
        if (!e.target.matches('.product-form__radio')) return;
        // Așteptăm HulkApps să-și actualizeze containerul activ
        setTimeout(syncFromActiveHulkAppsContainer, 300);
    });
})();

// ============================================================
// HulkApps Volume Discount – badge "Cea mai populară"
// Bucată: al 2-lea item (index 1) | Bax: al 3-lea item (index 2)
// ============================================================
(function () {
    var BADGE_TEXT    = 'Cea mai populară';
    var BADGE_CLASS   = 'popular-badge-ribbon';
    var POPULAR_CLASS = 'popular-item';

    // Injectăm stilurile o singură dată direct în <head> ca să nu depindă
    // de ordinea de încărcare a custom.css față de scripturile HulkApps
    function ensureStyles() {
        if (document.getElementById('popular-badge-styles')) return;
        var style = document.createElement('style');
        style.id = 'popular-badge-styles';
        style.textContent = [
            '.popular-item { position: relative !important; }',
            '.popular-badge-ribbon {',
            '  position: absolute;',
            '  top: -9px;',
            '  right: 11px;',
            '  background: #e63946;',
            '  color: #fff;',
            '  padding: 4px 14px;',
            '  font-size: 9px;',
            '  font-weight: 700;',
            '  z-index: 20;',
            '  border-radius: 4px;',
            '  line-height: 1;',
            '  pointer-events: none;',
            '}',
            '.popular-badge-ribbon::before {',
            '  content: "";',
            '  position: absolute;',
            '  left: -7px;',
            '  top: 0;',
            '  width: 0;',
            '  height: 0;',
            '  border-bottom: 8px solid #e63946;',
            '  border-left: 9px solid transparent;',
            '  border-top-right-radius: 4px;',
            '}',
            '.popular-badge-ribbon::after {',
            '  content: "";',
            '  position: absolute;',
            '  right: -6px;',
            '  top: 0;',
            '  width: 0;',
            '  height: 0;',
            '  border-bottom: 8px solid #e63946;',
            '  border-right: 8px solid transparent;',
            '}'
        ].join('\n');
        document.head.appendChild(style);
    }

    function injectBadges() {
        var containers = document.querySelectorAll('.hulkapps-volume-discount-tiers');
        if (!containers.length) return;

        containers.forEach(function (container) {
            // Curățăm badge-urile existente ca să nu se duplice
            container.querySelectorAll('.' + BADGE_CLASS).forEach(function (el) { el.remove(); });
            container.querySelectorAll('.' + POPULAR_CLASS).forEach(function (el) {
                el.classList.remove(POPULAR_CLASS);
            });

            // Al 3-lea item (index 2) pentru ambele containere
            var targetIndex = 2;

            var items = container.querySelectorAll('.offer-option-item');
            if (items.length <= targetIndex) return;

            var label = items[targetIndex].querySelector('label');
            if (!label) return;

            label.classList.add(POPULAR_CLASS);
            var badge = document.createElement('span');
            badge.className = BADGE_CLASS;
            badge.textContent = BADGE_TEXT;
            label.appendChild(badge);
        });
    }

    // Clonă salvată a first-item – folosită ca fallback când HulkApps uită să o adauge
    var savedFirstItem = null;

    function tryInject(attempt) {
        attempt = attempt || 0;

        var bucata = document.querySelector('.hulkapps-volume-discount-tiers.Discount-Bucata');

        if (bucata) {
            var fi = bucata.querySelector('.offer-option-item.first-item');

            if (fi) {
                // first-item prezent – salvăm o clonă proaspătă pentru utilizare ulterioară
                savedFirstItem = fi.cloneNode(true);
            } else if (attempt < 8) {
                // first-item lipsește, HulkApps poate să nu fi terminat – reîncercăm
                setTimeout(function () { tryInject(attempt + 1); }, 150);
                return;
            } else if (savedFirstItem) {
                // Am epuizat reîncercările și first-item tot nu e – îl restaurăm din clonă
                bucata.insertBefore(savedFirstItem.cloneNode(true), bucata.firstChild);
            }
        }

        injectBadges();
    }

    function startObserver() {
        var debounceTimer = null;

        var observer = new MutationObserver(function (mutations) {
            var shouldRun = mutations.some(function (m) {
                return Array.from(m.addedNodes).some(function (node) {
                    if (node.nodeType !== 1) return false;
                    if (node.classList.contains('hulkapps-volume-discount-tiers')) return true;
                    if (node.querySelector && node.querySelector('.hulkapps-volume-discount-tiers')) return true;
                    if (node.classList.contains('first-item') &&
                        m.target.closest && m.target.closest('.hulkapps-volume-discount-tiers')) return true;
                    return false;
                });
            });

            if (!shouldRun) return;

            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function () { tryInject(0); }, 150);
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            ensureStyles();
            tryInject(0);
            startObserver();
        });
    } else {
        ensureStyles();
        tryInject(0);
        startObserver();
    }
})();

// Optimize app-injected images that are downloaded at full resolution but displayed tiny.
// Appstle Loyalty button icon is served at 2160x2160 but displayed at 24x24 -> ~20 KiB waste.
(function optimizeAppIcons() {
    function shrinkShopifyCdn(url, width) {
        if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
        try {
            var u = new URL(url, window.location.origin);
            u.searchParams.set('width', String(width));
            return u.toString();
        } catch (e) { return url; }
    }

    function fix() {
        // Appstle Loyalty button icon
        var loyaltyIcons = document.querySelectorAll('img.loyalty-widget-buttonImage');
        loyaltyIcons.forEach(function (img) {
            if (img.dataset.klinOptimized) return;
            var newSrc = shrinkShopifyCdn(img.src, 96);
            if (newSrc !== img.src) img.src = newSrc;
            img.dataset.klinOptimized = '1';
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fix);
    } else {
        fix();
    }

    // Watch for late-injected app widgets (debounced)
    var t;
    var mo = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(fix, 200);
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });

    // Stop observing after 15s — apps inject early, no need to watch forever
    setTimeout(function () { mo.disconnect(); }, 15000);
})();

/**
 * Pozitia butoanelor plutitoare Pandectes (accesibilitate + cookie-uri).
 *
 * Ambele traiesc in shadow DOM (<pandectes-a11y> / <pandectes-cmp>), iar cel de
 * accesibilitate primeste `left`/`bottom` inline cu !important — deci nu pot fi
 * mutate din custom.css. Injectam un stylesheet in fiecare shadow root si
 * corectam pozitia cu margini: marginile deplaseaza cutia fixed fara sa intre
 * in conflict cu style-ul inline.
 *
 * Coloana din stanga, de jos in sus: cookie-uri, accesibilitate, contact flotant.
 * Ordinea cookie -> accesibilitate e impusa de app (isi ridica singur butonul
 * peste cel de cookie-uri), iar contactul flotant e mutat deasupra din
 * snippets/footer-floating-contact.liquid ca sa nu se calce cu meniul lui extins.
 *
 *   mobil (<=768px)                desktop (>=769px)
 *   [accesibil.] 110  [cos]  110   [contact]    160
 *   [cookie-uri]  45  [loial] 45   [accesibil.]  90  [cos]   90
 *   ------- bara Cont/Favorite/... [cookie-uri]  16  [loial] 24
 *
 * Offseturile appului sunt citite la runtime, nu hardcodate: daca appul isi
 * schimba pozitia (o face cand apare butonul de cookie-uri) recalculam.
 */
(function positionPandectesWidgets() {
    var MOBILE_MQ = '(max-width: 768px)';
    var LAYOUT = {
        'pandectes-a11y': { mobile: { side: 16, bottom: 110 }, desktop: { side: 30, bottom: 90 } },
        'pandectes-cmp': { mobile: { side: 16, bottom: 45 }, desktop: { side: 30, bottom: 16 } }
    };
    var TAGS = Object.keys(LAYOUT);

    function apply(tag) {
        var host = document.querySelector(tag);
        var root = host && host.shadowRoot;
        var widget = root && root.querySelector('.widget');
        if (!widget) return false;

        // Offseturile curente: inline la a11y, din stylesheet-ul appului la cmp.
        var cs = getComputedStyle(widget);
        var isLeft = widget.style.left !== '' || widget.classList.contains('left');
        var sideProp = isLeft ? 'left' : 'right';
        var side = parseFloat(widget.style[sideProp] || cs[sideProp]);
        var bottom = parseFloat(widget.style.bottom || cs.bottom);
        if (isNaN(side) || isNaN(bottom)) return false;

        var style = root.getElementById('klin-widget-position');
        if (!style) {
            style = document.createElement('style');
            style.id = 'klin-widget-position';
            root.appendChild(style);
        }

        // Emitem doar regula pentru breakpointul curent: appul isi recalculeaza
        // `bottom` in functie de viewport, deci un @media fix ar ramane in urma.
        var target = window.matchMedia(MOBILE_MQ).matches ? LAYOUT[tag].mobile : LAYOUT[tag].desktop;
        var css = '.widget{' +
            'margin-' + sideProp + ':' + (target.side - side) + 'px;' +
            'margin-bottom:' + (target.bottom - bottom) + 'px;}';
        if (style.textContent !== css) style.textContent = css;

        // Appul recalculeaza `bottom` cand apare/dispare butonul de cookie-uri.
        if (!widget.dataset.klinWatched) {
            widget.dataset.klinWatched = '1';
            new MutationObserver(function () { apply(tag); }).observe(widget, {
                attributes: true,
                attributeFilter: ['style', 'class']
            });
        }
        return true;
    }

    function applyAll() { TAGS.forEach(apply); }

    // Scripturile appurilor se incarca async, deci reincercam pana apar butoanele.
    TAGS.forEach(function (tag) {
        if (apply(tag)) return;
        var tries = 0;
        var timer = setInterval(function () {
            if (apply(tag) || ++tries > 100) clearInterval(timer); // max ~30s
        }, 300);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(applyAll, 150);
    });
})();


// ============================================================
// Verificare CUI în coș (completare Company Form - Romania) – 26.10.2026
// ============================================================
/* Klintensiv – verificare CUI în coș (completare pentru aplicația Company Form - Romania).
   Problema: când CUI-ul tastat nu e găsit (sau are cifra de control greșită), aplicația
   nu afișează nimic și lasă în coș firma găsită anterior, care ajunge pe factură.
   Soluția: la orice modificare a CUI-ului și la click pe „Finalizează cumpărăturile”,
   comparăm CUI-ul tastat cu cel salvat în coș; dacă diferă, ascundem firma veche,
   ștergem denumirea și adresa din coș și oprim trecerea la plată cu un mesaj clar. */
(function () {
  if (window.__klCuiGuard) return;
  window.__klCuiGuard = true;

  var MSG = 'Nu am găsit firma pentru acest CUI. Verifică cifrele și apasă pe lupă, apoi finalizează comanda.';

  function digits(v) { return String(v || '').replace(/\D/g, ''); }
  function cuiInput() { return document.querySelector('.company-form__container-cui input[placeholder="CUI"], .company-form__form input.input'); }
  function isPJ() {
    var r = document.querySelector('input[name="invoice_type"][value="pj"]');
    return !!(r && r.checked);
  }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function clearCompany() {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'CUI': '', 'Nume firmă': '', 'Adresă': '' } })
    });
  }
  function showWarning(on) {
    var box = document.querySelector('.company-form__result');
    if (!box) return;
    var valid = box.querySelector('.result-valid-cui');
    var w = box.querySelector('.kl-cui-warning');
    if (!w) {
      w = document.createElement('p');
      w.className = 'kl-cui-warning';
      w.style.cssText = 'color:#c0392b;font-weight:600;margin-top:6px;';
      w.textContent = MSG;
      box.appendChild(w);
    }
    w.style.display = on ? '' : 'none';
    if (valid && on) valid.style.display = 'none';
    if (valid && !on) valid.style.display = '';
  }

  /* Starea: true = CUI-ul tastat nu corespunde firmei din coș */
  function check() {
    var inp = cuiInput();
    if (!inp || !isPJ()) { showWarning(false); return Promise.resolve(false); }
    var typed = digits(inp.value);
    if (!typed) { showWarning(false); return Promise.resolve(false); }
    return getCart().then(function (c) {
      var a = c.attributes || {};
      var ok = digits(a['CUI']) === typed && String(a['Nume firmă'] || '').trim() !== '';
      if (!ok && (a['Nume firmă'] || a['Adresă'] || a['CUI'])) clearCompany();
      showWarning(!ok);
      return !ok;
    }).catch(function () { return false; });
  }

  var t;
  document.addEventListener('input', function (e) {
    if (e.target && e.target === cuiInput()) {
      clearTimeout(t);
      t = setTimeout(check, 3500); /* lasă aplicației timp să caute firma */
    }
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'invoice_type') setTimeout(check, 500);
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.company-form__submit')) {
      clearTimeout(t);
      t = setTimeout(check, 3500);
    }
  }, true);

  /* Blocare la finalizare dacă CUI-ul nu corespunde */
  /* pe window (capture), ca să ruleze înaintea handler-ului Hulk Discounts de pe document */
  var passing = false;
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('#cart-checkout, [name="checkout"]');
    if (!btn || passing) return;
    var inp = cuiInput();
    if (!inp || !isPJ() || !digits(inp.value)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    check().then(function (bad) {
      if (bad) {
        inp.scrollIntoView({ block: 'center' });
        inp.focus();
      } else {
        passing = true;
        btn.click();
        setTimeout(function () { passing = false; }, 1500);
      }
    });
  }, true);
})();

/* ================================================================
   KlinFriday 2026 · teancul lipit de sus (sticky)
   Ticker + header principal + bara CATEGORII pe desktop; ticker + headerul
   de mobil sub 1025px. Trei variabile pe <html>, folosite din CSS:
     --kf-ticker-h    inaltimea tickerului
     --kf-ann-h       inaltimea sectiunii lui (ticker + banda KLIN-FRIDAY),
                      din care se calculeaza cat de sus se lipeste sectiunea
     --kf-sticky-top  inaltimea headerului principal
                      (bara CATEGORII se aseaza sub ticker + el)
     --kf-sticky-h    inaltimea intregului teanc lipit, pentru elementele
                      care se lipesc mai jos in pagina (sidebar-ul de colectie,
                      meniul lateral de pe paginile promo) si pentru
                      scroll-margin-top la ancore
   Regulile sunt in assets/custom.css si assets/klin-friday-promo.css.
   ================================================================ */
(function () {
  var header = document.querySelector('.shopify-section.section-header-advanced');
  var nav = document.querySelector('.shopify-section.section-header-navigation');
  var mobile = document.querySelector('.shopify-section.section-header-mobile');
  var ann = document.querySelector('.shopify-section.kf-announcement');
  var ticker = ann ? ann.querySelector('.kf-ticker') : null;
  if (!header && !mobile) return;

  function h(el) {
    /* sectiunile ascunse pe breakpointul curent au inaltime 0, deci se scot singure */
    return el ? el.getBoundingClientRect().height : 0;
  }

  function measure() {
    var root = document.documentElement;
    var tickerH = Math.round(h(ticker));
    root.style.setProperty('--kf-ticker-h', tickerH + 'px');
    root.style.setProperty('--kf-ann-h', Math.round(h(ann)) + 'px');
    root.style.setProperty('--kf-sticky-top', Math.round(h(header)) + 'px');
    root.style.setProperty('--kf-sticky-h', tickerH + Math.round(h(mobile) + h(header) + h(nav)) + 'px');
  }

  measure();
  window.addEventListener('load', measure);
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(measure);
    [header, nav, mobile, ticker, ann].forEach(function (el) { if (el) ro.observe(el); });
  } else {
    window.addEventListener('resize', measure);
  }
})();
